import React, { useEffect } from 'react';
import useDataApi from './useDataApi';
import config from '../config/config';

// get markers for map without a selected submarket
const useGetMarkers = () => {
	const [ states, setStates ] = React.useState( [] );

	const query = useDataApi(
		`${ config.API_ENDPOINT }search-data`,
		{ data: [] },
	);

	useEffect( () => {
		if ( ! query.data ) {
			return;
		}
		const finalStates = query.data.states.map( ( state ) => ( {
			...state,
			_geoloc: {
				lat: state.lat,
				lng: state.lng,
			},
			objectID: state.slug,
			type: 'state',
		} ) );
		setStates( finalStates );
	}, [ query.data ] );

	return {
		isLoading: query.isLoading,
		isError: query.isError,
		states: ! query.data ? null : states,
	};
};

export default useGetMarkers;
